import ReactDOM from 'react-dom/client';
import ThemeProvider from './ThemeProvider.tsx';
import './index.css';
import './lang/config.ts';

ReactDOM.createRoot(document.getElementById('root')!).render(<ThemeProvider />);
